module.exports = __webpack_public_path__ + "static/img/hy1.4bfac03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hy1.png
// module id = +YVr
// module chunks = 0